// extracted by mini-css-extract-plugin
export default {"excelForm":"UploadUserExcel_excelForm__pDiHp"};